import { OnlineSalesUnauthenticated } from 'gw-edge-client';
import { useRecoilValue } from 'recoil';
import { isLoggedOnSelector } from '../recoil/selectors/isLoggedOnSelector';
import { jobInfoAtom } from '../recoil/atoms/jobInfoAtom';
import { type ClaimsHistoryInformationToUpdateDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/onsa';

export function useSaveClaimsHistoryInformation(): {
    saveClaimsHistoryInformation: (
        updatedCoverable: ClaimsHistoryInformationToUpdateDTO
    ) => Promise<void>;
} {
    const { jobNumber, sessionId } = useRecoilValue(jobInfoAtom);
    const isLoggedOn = useRecoilValue(isLoggedOnSelector);

    const saveClaimsHistoryInformation = async (
        updatedCoverable: ClaimsHistoryInformationToUpdateDTO
    ): Promise<void> => {
        await OnlineSalesUnauthenticated.saveClaimsHistoryInformation(
            jobNumber,
            updatedCoverable,
            sessionId,
            !isLoggedOn
        );
    };

    return { saveClaimsHistoryInformation };
}
